import {HttpHeaders, HttpParams} from '@angular/common/http';

export class RequestConfiguration {
    headers: HttpHeaders;
    parameters: HttpParams;
}
